<template>
  <div class="d-flex flex-wrap align-items-center mb-2 status-filter-bar">
    <b-badge
      variant="dark"
      class="status-filter-pill mr-2 mb-1"
      :class="{ 'status-filter-inactive': !allSelected }"
      @click="clear"
    >
      All ({{ total }})
    </b-badge>
    <b-badge
      v-for="(stateInfo, stateKey) in visibleStates"
      :key="stateKey"
      :variant="stateInfo.color"
      class="status-filter-pill mr-2 mb-1"
      :class="{ 'status-filter-inactive': !allSelected && !isActive(stateKey) }"
      @click="toggle(stateKey)"
    >
      {{ stateInfo.verboseName }} ({{ counts[stateKey] || 0 }})
    </b-badge>
  </div>
</template>

<script>
export default {
  name: "StatusFilterBar",
  props: {
    states: {
      type: Object,
      required: true,
    },
    selected: {
      type: Array,
      default: () => [],
    },
    counts: {
      type: Object,
      default: () => ({}),
    },
    total: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    allSelected() {
      return this.selected.length === 0;
    },
    visibleStates() {
      const visible = {};
      Object.entries(this.states).forEach(([stateKey, stateInfo]) => {
        if ((this.counts[stateKey] || 0) > 1) {
          visible[stateKey] = stateInfo;
        }
      });
      return visible;
    },
  },
  methods: {
    isActive(stateKey) {
      return this.selected.includes(stateKey);
    },
    toggle(stateKey) {
      const next = this.isActive(stateKey)
        ? this.selected.filter((s) => s !== stateKey)
        : [...this.selected, stateKey];
      this.$emit("update:selected", next);
    },
    clear() {
      this.$emit("update:selected", []);
    },
  },
};
</script>

<style scoped>
.status-filter-pill {
  cursor: pointer;
  font-size: 0.85rem;
  padding: 0.4em 0.7em;
  transition: opacity 0.15s ease;
}
.status-filter-inactive {
  opacity: 0.35;
}
</style>
